import React from 'react'

export const NoPermissions: React.FunctionComponent<{ noGroups?: boolean }> = props => {
  return (
    <div className="row">
      <div className="col-md-6 col-md-offset-3">
        <div className="panel reference-box">
          <div className="panel-heading">No Permissions</div>
          <div className="panel-body">
            {!props.noGroups && (
              <>
                <h2>You don't have permissions yet.</h2>
                <p className="lead">Please wait while we confirm your account.</p>
              </>
            )}
            {props.noGroups && <p className="lead">You do not have permission. Contact an admin for access</p>}
          </div>
        </div>
      </div>
    </div>
  )
}
